'use strict';

const createWidgetFactory = require('components-framework/widget/create_widget_factory');

module.exports = createWidgetFactory({
    name: 'booking_itinerary',
    viewClass: require('./view'),
    modelClass: require('./model'),
    methods: {
        loadXSELLModule(data) {
            this.loadXSELLModule(data);
        },
        updateItineraryScheduleChanges(data) {
            this.updateItineraryScheduleChanges(data);
        },
        showSegmentsItineraryBox() {
            this.showSegmentsItineraryBox();
        },
    },
});
